export { PrizesSection } from "./prizes-section";
